import { render, staticRenderFns } from "./home_pc.vue?vue&type=template&id=114bfac8&scoped=true&"
import script from "./home_pc.vue?vue&type=script&lang=js&"
export * from "./home_pc.vue?vue&type=script&lang=js&"
import style0 from "./home_pc.vue?vue&type=style&index=0&id=114bfac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114bfac8",
  null
  
)

export default component.exports